import { TableFilters, TableFilterSelect, SearchableSelect } from '../../../design-system';
import { useStore } from '../../../context';
import { belongsToOptions, belongsToOptionsQueryKeys } from '../../../services';
import { showToRoles } from '../../../utils';
import {
  employeesAccountStatus,
  employeesFormCompanyRolesOptions,
  employeesTableCompanyTitle,
} from '../../../const';
import { i18n } from '../../../i18n';

interface Props {
  belongsTo: 'YardCompany' | 'Yard' | 'Client';
  companyName?: string;
  companyId?: string;
  firstName?: string;
  lastName?: string;
  accountStatus?: string;
  setStates: any;
  handlePageChange: (e: any, page: number) => void;
}

export const Filters: React.FC<Props> = ({
  belongsTo,
  companyName,
  companyId = '',
  accountStatus,
  setStates,
  handlePageChange,
}: Props) => {
  const {
    state: {
      user: { data: user },
    },
  } = useStore();

  return (
    <TableFilters>
      {showToRoles(['SUPER_ADMIN', 'YARD_COMPANY_ADMIN', 'YARD_COMPANY_VIEWER'], user) && (
        <TableFilterSelect
          label={i18n.t('label.belongsTo')}
          options={employeesFormCompanyRolesOptions[user.type]}
          value={belongsTo}
          onChange={(e) => {
            setStates('force', {
              belongsTo: e.target.value,
              companyName: '',
              companyId: '',
            });
            handlePageChange(null, 1);
          }}
          withoutEmptyValue
        />
      )}
      {(showToRoles(['SUPER_ADMIN'], user) ||
        (belongsTo !== 'YardCompany' &&
          showToRoles(
            ['YARD_COMPANY_ADMIN', 'YARD_COMPANY_EMPLOYEE', 'YARD_COMPANY_VIEWER'],
            user,
          ))) && (
        <SearchableSelect
          selectedOptionLabel={companyName}
          label={employeesTableCompanyTitle[belongsTo]}
          onSelect={(obj) => setStates('force', { companyName: obj.label, companyId: obj.id })}
          queryFn={() =>
            belongsTo === 'Client'
              ? belongsToOptions[belongsTo]('', true, true)
              : belongsTo === 'Yard'
              ? () => belongsToOptions[belongsTo]('', true, 'yard')
              : belongsToOptions[belongsTo]('', true)
          }
          queryKey={[belongsToOptionsQueryKeys[belongsTo], belongsTo]}
          selectedAreasEqaul={{ key: 'id', keys: [companyId] }}
          withClearButton
        />
      )}
      <TableFilterSelect
        label={i18n.t('label.accountStatus')}
        options={employeesAccountStatus}
        value={accountStatus}
        onChange={(e) => setStates('force', { accountStatus: e.target.value })}
        withoutEmptyValue
      />
    </TableFilters>
  );
};
